var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('div',{ref:"childrenWrapper",staticClass:"children-wrapper"},[_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }